import { Component } from '@angular/core';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { ProgressSpinnerModule } from 'primeng/progressspinner';

@Component({
  selector: 'app-block-ui-dialog',
  standalone: true,
  imports: [ProgressSpinnerModule],
  template: `
    <div class="flex flex-column align-items-center">
      <p-progressSpinner [style]="{width: '100px', height: '100px'}"></p-progressSpinner>
      <span class="mt-3">{{ config.data?.message || 'Loading...' }}</span>
    </div>
  `,
  styles: [`
    :host {
      display: block;
      padding: 1.5rem;
    }
  `]
})
export class BlockUiDialogComponent {
  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig
  ) {}
}
